import {
    EyeOutlined
} from '@ant-design/icons';
import { Flex } from "antd";
import TableAntd from 'components/elements/Table/Table';
import { get2DecimalPointsWithCommas } from 'components/numberFormatDigits';
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import styles from "../styles/Payment.module.css";
import { useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import TableAntdFix from 'components/elements/Table/TableFixPage';

const ApprovalTable = ({
    dataSource = [],
    onChange = () => { },
    pagination = {},
    isLoading = false,
    onView = () => { },
    onEdit = () => { },
    step = 0,
    visible = false,
    rowSelection = {},
}) => {
    const { t, i18n } = useTranslation();

    const navigate = useNavigate();
    const params = useParams()
    const { roles } = useSelector((state) => state.company);

    const onViewEmployee = useCallback(
        (obj) => {
            console.log("obj", obj, params);
            const id = obj?.employeeId;
            // console.log("onView", EMPLOYEE_MENU_LIST.filter(o => o.label), `${EMPLOYEE_MENU_LIST.filter(o => o.label)?.[0].key}`);
            // navigate("/configuration/attendance", { state: { selectedTab: 'shifts' } });
            if (id) navigate(`/employee/${id}/employee_info`, { state: { selectedTab: `/payroll/payment/${params.id}` } });
        },
        [navigate, params]
    );


    const columns = [
        {
            title: <div className="text-table">{t("user_management.label.employee_id")}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            render: (_, record) => {
                console.log("record?.employee 1", record);
                return !roles.includes("ACCESS_EMPLOYEE") ? record?.employeeNo : <a onClick={() => {
                    console.log("click");
                    onViewEmployee(record)
                }} >{record?.employeeNo}</a>
            }
        },
        {
            title: <div className="text-table">{t("employee_list.header")}</div>,
            dataIndex: "employeeName",
            key: "employeeName",
            width: "170px",
            render: (_, record) => {
                return (
                    <Flex >{i18n.language === 'en' ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.numberOfWorkingDays')}</div>,
            dataIndex: "totalWorkingDays",
            key: "totalWorkingDays",
            width: "80px",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='center' >{record?.totalWorkingDays || 0}</Flex>
                    // <Flex >{record?.totalWorkingDays + "/" + record?.daysForDividing || 0}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t("salary.label.salary")}</div>,
            dataIndex: "totalIncome",
            key: "totalIncome",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='flex-end'>{visible ? get2DecimalPointsWithCommas(record?.totalIncome) : "xxxxx.xx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table"> {t('edit.income.deduction')}</div>,
            dataIndex: "otherIncome",
            key: "otherIncome",
            align: 'center',
            render: (_, record) => {
                return (
                    record?.approveStatusCode !== 'APPROVED' ? (
                        <Flex gap="5px" justify='center'>
                            {
                                step == 0 ?
                                    <EditIcon onClick={() => onEdit(record)} style={{ cursor: "pointer" }} /> :
                                    <EyeOutlined onClick={() => onView(record)} />
                            }
                        </Flex>
                    ) : null
                );
            }
        },
        {
            title: <div className="text-table">{t('payment.label.withholding-tax')}</div>,
            dataIndex: "withholdingTax",
            key: "withholdingTax",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='flex-end'>{visible ? get2DecimalPointsWithCommas(record?.withholdingTax) : "xxxxx.xx"}</Flex>
                )
            }

        },
        {
            title: <div className="text-table">{t('payment.label.social_security')}</div>,
            dataIndex: "socialSecurity",
            key: "socialSecurity",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='flex-end'> {visible ? get2DecimalPointsWithCommas(record?.socialSecurity) : "xxxxx.xx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.tax')}</div>,
            dataIndex: "taxRate",
            key: "taxRate",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='center'>{visible ? get2DecimalPointsWithCommas(record?.taxRate, 0) : "xxxxx.xx"}</Flex>
                )
            }
        },

        {
            title: <div className="text-table">{t('payment.label.net_income')}</div>,
            dataIndex: "netIncome",
            key: "netIncome",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='flex-end'>{visible ? get2DecimalPointsWithCommas(record?.netIncome) : "xxxxx.xx"}</Flex>
                )
            }
        },
        {
            title: <div className="text-table">{t('payment.label.emailSend')}</div>,
            dataIndex: "exportStatus",
            key: "exportStatus",
            align: 'center',
            render: (_, record) => {
                return (
                    <Flex justify='center'>{i18n.language === 'en' ? record?.exportStatusEn : record?.exportStatus}</Flex>
                )
            }
        },

    ];

    return (
        <>
            <TableAntdFix
                rowSelection={false}
                className={styles.table}
                style={{
                    border: '1px solid lightgray',
                    borderRadius: "8px"
                }}
                loading={isLoading}
                pagination={{
                    ...pagination,
                }}
                dataSource={dataSource}
                rowKey={(record) => record?.txnPaymentId}
                columns={columns}
                onChange={onChange}
            // scroll={{ x: true }}

            />
            {/* <Row justify='end' style={{
                marginTop: "10px"
            }}>
                <Flex gap={20} style={{ marginTop: "24px" }}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        onClick={() => { onRejected() }}
                        disabled={rowSelected?.length > 0 ? false : true}
                    >
                        {t('payment.label.reject')}
                    </Button>
                    {getButtonByStep()}
                </Flex>
            </Row > */}
        </>


    );
};

export default ApprovalTable;
